import { SxProps } from '@mui/material';

export const NavBarStyles = {
  container: {
    background: 'transparent',
    boxShadow: 'none',
    color: 'rgb(2, 2, 93)',
  },
  menuItem: {
    my: 2,
    fontWeight: 600,
    color: 'rgb(13, 39, 84)',
    display: 'block',
    textTransform: 'none',
    fontSize: '0.95rem',
    letterSpacing: '0.3px',
    transition: 'all 0.2s ease',
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      width: '0',
      height: '2px',
      bottom: '0',
      left: '50%',
      backgroundColor: 'rgb(13, 39, 84)',
      transition: 'all 0.3s ease',
      transform: 'translateX(-50%)',
    },
    '&:hover': {
      '&:after': {
        width: '100%',
      },
    },
  },
  icon: {
    display: { xs: 'none', md: 'flex' },
    mr: 1,
    color: 'rgb(13, 39, 84)',
    transition: 'transform 0.2s ease',
    '&:hover': {
      cursor: 'pointer',
      transform: 'scale(1.1)',
    },
  },
  logo: {
    mr: 2,
    display: { xs: 'none', md: 'flex' },
    fontFamily: '"Higuen Serif", serif',
    fontWeight: 700,
    letterSpacing: '.3rem',
    color: 'rgb(13, 39, 84)',
    textDecoration: 'none',
    transition: 'all 0.2s ease',
    '&:hover': {
      cursor: 'pointer',
      transform: 'translateY(-2px)',
    },
  },
  pages: {
    flexGrow: 1,
    display: { xs: 'none', md: 'flex' },
    gap: '20px',
    justifyContent: 'center',
  },
  avatar: {
    bgcolor: 'rgb(13, 39, 84)',
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
  customDropdown: {
    position: 'absolute',
    top: '100%',
    right: 0,
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    minWidth: '180px',
    zIndex: 1000,
    overflow: 'hidden',
    border: '1px solid rgba(0, 0, 0, 0.05)',
  },
  customMenuItem: {
    padding: '12px 16px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    position: 'relative',
    '&:hover': {
      backgroundColor: 'rgba(13, 39, 84, 0.08)',
    },
    '&:active': {
      backgroundColor: 'rgba(13, 39, 84, 0.12)',
    },
    '&:not(:last-child)': {
      borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
    },
  },
  menuItemText: {
    textAlign: 'center',
    fontWeight: 500,
    color: 'rgb(13, 39, 84)',
    transition: 'all 0.2s ease',
  },
} satisfies Record<string, SxProps>;
